export default __webpack_public_path__ + "static/media/line.af76327d.svg";